import { getCurrentBreakpoint } from '../utilities/device';
import { breakpoints } from '../common/constants/breakpoints';

export const toggleClass = (sectionWrapper, toggleClassName) => {
    sectionWrapper.classList.toggle(toggleClassName);
};

const chevron = (sectionWrapper) => {
    const chevronElem = sectionWrapper.querySelector('.c-collapseSection__headerContent');
    const chevronRotateClass = 'c-collapseSection__headerContent--ifExpanded';

    toggleClass(chevronElem, chevronRotateClass);
};

const accordion = (
    accordionSection,
    sectionTriggerClassName,
    sectionWrapperClassName,
    toggleClassName
) => {
    const sectionTrigger = accordionSection.querySelector(sectionTriggerClassName);
    const sectionWrapper = accordionSection.querySelector(sectionWrapperClassName);

    sectionTrigger.addEventListener('click', () => { 
        toggleClass(sectionWrapper, toggleClassName);
        chevron(sectionTrigger);
    });
};

export const accordions = () => {
    const offerContainers = document.querySelectorAll('.js-collapse');
    const sectionTriggerClassName = '.c-collapseSection__header';
    const sectionWrapperClassName = '.c-collapseSection__wrapper';
    const toggleClassName = 'c-collapseSection__wrapper--isCollapsed';

    Array.from(offerContainers).forEach((accordionSection) => {
        accordion(accordionSection, sectionTriggerClassName, sectionWrapperClassName, toggleClassName);
    });
};

export const mobileAccordions = () => {
    const currentBreakpoint = getCurrentBreakpoint();
    const offerContainers = document.querySelectorAll('.js-mobileCollapse');
    const sectionTriggerClassName = '.c-collapseSection__mobileHeader';
    const sectionWrapperClassName = '.c-collapseSection__mobileWrapper';
    const toggleClassName = 'c-collapseSection__mobileWrapper--isCollapsed';

    if (currentBreakpoint === breakpoints.xSmall || currentBreakpoint === breakpoints.small) {
        Array.from(offerContainers).forEach((accordionSection) => { 
            accordion(accordionSection, sectionTriggerClassName, sectionWrapperClassName, toggleClassName);
        });
    }
};
